import { useLocale } from '../../../../../i18n';
import useAuth from '../../../../app/src/features/authentication/hooks/useAuth';
import { getFlowInfo } from '../../../../flows/src/api/getFlowInfo';
import {
  flowIdCitizinsTravel,
  flowIdTechniekNL,
} from '../../../../flows/src/constants/flowIds';
import useFlowsInitNew from '../../../../flows/src/hooks/init/useFlowsInitNew';
import useFlowsResetState from '../../../../flows/src/hooks/useFlowsResetState';
import { FlowInfo } from '../../../../flows/src/types/FlowsTypes';

const useStartDefaultSalesConversationFlow = () => {
  const { initFlow } = useFlowsInitNew();
  const { userLang } = useLocale();
  const { campaign } = useAuth();
  const { reset } = useFlowsResetState();

  const getOutputUrl = (flowInfo: FlowInfo) => {
    if (flowInfo.id === flowIdTechniekNL) {
      return '/sales-conversation/techniek-nederland/finalize';
    }
    if (flowInfo.id === flowIdCitizinsTravel) {
      return '/sales-conversation/offers/overview/travel';
    }
    if (flowInfo.type === 'offer') {
      return '/sales-conversation/offers/overview/default';
    }
    return `/sales-conversation/default/finalize`;
  };

  return async ({
    flowId,
    uuid,
    inputUrl,
    partyId,
    quoteId,
    quoteIds,
  }: {
    flowId: string;
    uuid?: string;
    inputUrl?: string;
    partyId?: string;
    quoteId?: string;
    quoteIds?: string[];
  }) => {
    reset();

    const flowInfo = await getFlowInfo(flowId, { lang: userLang });

    await initFlow({
      flowId: flowId,
      payload: {
        party_id: partyId,
        quote_id: quoteId,
        quote_ids: quoteIds,
        previous_session_id: flowInfo.previous ? uuid : undefined,
        subject: campaign?.subjects?.length ? campaign.subjects : undefined,
      },
      inputUrl,
      outputUrl: getOutputUrl(flowInfo),
      sessionId: uuid,
      shouldComplete: false,
    });
  };
};

export default useStartDefaultSalesConversationFlow;
